import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=2584c45d&scoped=true&"
import script from "./AdminLayout.vue?vue&type=script&lang=js&"
export * from "./AdminLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584c45d",
  null
  
)

export default component.exports